"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestOrderLineVersion = void 0;
const immer_1 = require("immer");
const _ = require("lodash");
const getLatestOrderLineVersion = (versions) => {
    if (!versions || versions.length === 0)
        return null;
    const sortedVersions = (0, immer_1.produce)(versions, (draft) => {
        draft.sort((a, b) => {
            if (!a.created_at || !b.created_at)
                return 0;
            return (new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
        });
    });
    return _.cloneDeep(sortedVersions[0]);
};
exports.getLatestOrderLineVersion = getLatestOrderLineVersion;
